// extracted by mini-css-extract-plugin
export var accentColor = "#ff723d";
export var categoryBorderColor = "#2d69c2";
export var disableRipple = "true";
export var fontFamily = "\"Roboto\",\"Helvetica\",\"Arial\",sans-serif";
export var mainColor = "#2d69c2";
export var mainContrast = "#fff";
export var panelBorderColor = "#c4c8cd";
export var secondaryColor = "#1c4282";
export var secondaryContrast = "#fff";